/* eslint import/prefer-default-export: 0 */

const lazyCmpConfig = {
  loading: {
    template: "<div>Async loading!</div>"
  },
  error: {
    template: "<div>ERROR loading!</div>"
  },
  delay: 200,
  timeout: 10000
};

export const Dashboard = () => ({
  component: import("@/superAdmin/components/sections/dashboard/DashboardIndex/index.vue"),
  ...lazyCmpConfig
});

export const CompanyList = () => ({
  component: import("@/superAdmin/components/sections/companies/CompanyList/index.vue"),
  ...lazyCmpConfig
});

export const CreateCompany = () => ({
  component: import("@/superAdmin/components/sections/companies/CreateCompany/index.vue"),
  ...lazyCmpConfig
});

export const EditCompany = () => ({
  component: import("@/superAdmin/components/sections/companies/EditCompany/index.vue"),
  ...lazyCmpConfig
});
